import React from 'react'
import { Button, Spinner, Text, View } from 'oio-react'
import PropTypes from 'prop-types'
import { useInitiativeList } from 'src/graphql/hooks'

const InitiativeList = ({ children, filter }) => {
   const { initiativeList, fetchMore, loading, networkStatus } = useInitiativeList({
      archived: 'exclude',
      sortBy: 'popularity',
      ...filter
   })

   const initialLoading = networkStatus <= 2

   const handleLoadMore = () => {
      fetchMore({
         variables: {
            start: initiativeList.listInfo.nextCursor
         },
         updateQuery: (prevResult, { fetchMoreResult }) => {
            if (!fetchMoreResult) {
               return prevResult
            }

            return {
               ...prevResult,
               initiativeList: {
                  ...prevResult.initiativeList,
                  items: [
                     ...prevResult.initiativeList.items,
                     ...fetchMoreResult.initiativeList.items
                  ],
                  listInfo: fetchMoreResult.initiativeList.listInfo
               }
            }
         }
      })
   }

   return (
      <>
         {loading && (
            <View
               width="100%"
               padding="40px 10px"
               textAlign="center">
               <Spinner color="#ccc" width="20px" height="20px" />
            </View>
         )}
         {!initialLoading && (
            <>
               {initiativeList.items.length === 0 && (
                  <View
                     width="100%"
                     padding="30px 10px">
                     <Text size="2" color="#aaa">No items to show</Text>
                  </View>
               )}
               {children(initiativeList)}
               {initiativeList.listInfo.hasNext && (
                  <View
                     float="left"
                     width="100%"
                     display="flex"
                     justifyContent="center"
                     borderTop="1px solid #eee"
                     margin="20px 0px"
                     padding="20px 0px">
                     <Button
                        color="#eee"
                        textColor="#333"
                        size="xs"
                        onClick={handleLoadMore}
                        name="Load More"
                        mode={loading ? 'loading' : 'normal'}
                     />
                  </View>
               )}
            </>
         )}
      </>
   )
}

InitiativeList.propTypes = {
   children: PropTypes.func.isRequired,
   filter: PropTypes.object
}

InitiativeList.defaultProps = {
   filter: {}
}

export default InitiativeList
